import { useState } from "react";
import SelectBaseAntd, { SelectBaseAntdProps } from "../SelectBaseAntd";
import { showSuccess } from "infra/helpers/alerta";
import { Box } from "@chakra-ui/react";
import { Button } from "@chakra-ui/react";
import { useDebounce } from "core/features/shared/useDebouce";

import { useListarEquipamentos } from "core/features/equipamento/hooks/useListarEquipamentos";
import ModalCadastrarEquipamento from "./../../../pages/Admin/Administracao/Equipamentos/Listagem/components/ModalCadastrarEquipamento/index";

export interface SelectEquipamentoProps<T = any>
  extends SelectBaseAntdProps<T> {}

function SelectEquipamento({ ...rest }: SelectEquipamentoProps) {
  const [isOpenModal, setIsOpenModal] = useState(false);

  const [search, setSearch] = useState<string>();

  const debouncedSearch = useDebounce(search);

  const { isLoading, data, isFetching, refetch } = useListarEquipamentos({
    search: debouncedSearch,
  });

  const handleSuccess = ({ id, nome }: { id: string; nome: string }) => {
    setIsOpenModal(false);

    setTimeout(() => {
      showSuccess(`Equipamento salvo com sucesso`).then(() => {
        refetch();
        rest.onChange?.(id, { value: id, label: nome });
      });
    }, 500);
  };

  const _isLoading = isLoading || isFetching;

  return (
    <>
      {isOpenModal ? (
        <ModalCadastrarEquipamento
          visible={isOpenModal}
          onClose={() => setIsOpenModal(false)}
          onSaved={(id, nome) => handleSuccess({ id: id!, nome: nome! })}
        />
      ) : null}
      <SelectBaseAntd
        loading={_isLoading}
        size="large"
        placeholder="Selecione um equipamento"
        searchValue={search}
        showSearch
        onSearch={setSearch}
        optionFilterProp="label"
        options={data?.items.map((item) => ({
          value: item.id,
          label: item.nome,
        }))}
        {...rest}
        notFoundContent={
          !_isLoading ? (
            <Box>
              Nenhum equipamento encontrada{" "}
              <Button
                isLoading={isLoading}
                leftIcon={<i className="mdi mdi-plus" />}
                size="xs"
                colorScheme="orange"
                onClick={() => setIsOpenModal(true)}
              >
                cadastrar nova
              </Button>
            </Box>
          ) : (
            <Box>Carregando...</Box>
          )
        }
      />
    </>
  );
}

export default SelectEquipamento;
